import { render, staticRenderFns } from "./SyncTaskCenter.vue?vue&type=template&id=451cac9b&scoped=true"
import script from "./SyncTaskCenter.vue?vue&type=script&lang=js"
export * from "./SyncTaskCenter.vue?vue&type=script&lang=js"
import style0 from "./SyncTaskCenter.vue?vue&type=style&index=0&id=451cac9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451cac9b",
  null
  
)

export default component.exports